<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 27.333c6.26 0 11.334-5.074 11.334-11.334C27.334 9.74 22.26 4.666 16 4.666c-6.259 0-11.333 5.074-11.333 11.333 0 6.26 5.074 11.334 11.333 11.334zm0 2c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334z" clip-rule="evenodd"/><path d="M16.245 18.63c.346 0 .632-.234.65-.532l.438-7.51c.019-.32-.278-.589-.65-.589h-1.365c-.373 0-.67.27-.65.59l.446 7.51c.018.298.304.532.65.532h.48zM16 21.833c.737 0 1.334-.561 1.334-1.253 0-.692-.597-1.253-1.334-1.253-.736 0-1.333.56-1.333 1.253 0 .692.597 1.253 1.333 1.253z"/></svg>
</template>

<script>
export default {
  name: 'symbolsCircleAlertOutline'
}
</script>
